/* eslint-disable react/no-unused-prop-types */
import React from "react";
import { BasicTooltip, tooltipPositions } from "@streeteasy/design-system";
import moment from "moment-timezone";
import { bool, shape, string } from "prop-types";

import { noListingImage } from "../../assets";
import { useOHBehavior, useOHData } from "../../redux/hooks/openHousesHooks";
import { useUIBehavior } from "../../redux/hooks/uiHooks";
import AddToCalendar from "../AddToCalendar";
import PastOpenHouseActions from "./components/PastOpenHouseActions";
import * as S from "./styled";

const OpenHouseItemActivity = props => {
  const { sendAddToCalendarGA } = useUIBehavior();
  const { acknowledgeUpdateOH, deregisterOH } = useOHBehavior();
  const { acknowledgeOHs } = useOHData();
  const imageUrl = props.imageUrl.includes("no_photo")
    ? noListingImage
    : props.imageUrl;
  const isAcknowledge = acknowledgeOHs.includes(props.id);
  const isHiglight =
    (props.isCanceled || props.isTimeChanged) &&
    !isAcknowledge &&
    !props.isPastOH;

  const renderOpenHouseTimeWindow = () => {
    const startTime = moment(props.startsAt)
      .tz("America/New_York")
      .format("LT");
    const endTime = moment(props.endsAt)
      .tz("America/New_York")
      .format("LT");
    return (
      <>
        {startTime} - {endTime}
      </>
    );
  };

  const onAnalyticsEvent = openHouseId => {
    sendAddToCalendarGA(openHouseId);
  };

  return (
    <>
      <S.Wrapper>
        <S.ImageLinkWrapper href={props.listingLink} target="_blank">
          <S.ListingImage src={imageUrl} />
        </S.ImageLinkWrapper>
        <S.InfoBox>
          <S.Link href={props.listingLink} isCanceled={props.isCanceled}>
            {props.listingAddress}
          </S.Link>
          <S.OHTime isHiglight={isHiglight}>
            <S.OHTimeText isCanceled={props.isCanceled}>
              {renderOpenHouseTimeWindow()}
            </S.OHTimeText>
            {props.isCanceled && !isAcknowledge && !props.isPastOH && (
              <S.Notice isError>Canceled</S.Notice>
            )}
            {props.isTimeChanged && !isAcknowledge && !props.isPastOH && (
              <S.Notice>New time</S.Notice>
            )}
          </S.OHTime>
        </S.InfoBox>
        {!props.isPastOH && (
          <S.Actions>
            {!props.isCanceled && (
              <S.AddToCalendarWrapper>
                <AddToCalendar
                  handleAnalyticsEvent={openHouseId =>
                    onAnalyticsEvent(openHouseId)
                  }
                  openHouseData={props.openHouseData}
                  openHouseId={props.id}
                />
              </S.AddToCalendarWrapper>
            )}
            <BasicTooltip
              className="a11y"
              content="Remove"
              position={tooltipPositions.BOTTOM}
            >
              <S.RemoveButton
                onClick={() => {
                  deregisterOH(props.id);
                }}
              >
                <S.RemoveIcon />
              </S.RemoveButton>
            </BasicTooltip>
          </S.Actions>
        )}
      </S.Wrapper>
      {props.isTimeChanged && !isAcknowledge && !props.isPastOH && (
        <S.Confirmation>
          The time has changed.
          <S.GotItButton
            onClick={() => acknowledgeUpdateOH(props.savedOHId, props.id)}
          >
            Got it
          </S.GotItButton>
        </S.Confirmation>
      )}
      {props.isCanceled && !isAcknowledge && !props.isPastOH && (
        <S.Confirmation>
          Canceled by the agent.
          <S.GotItButton
            onClick={() => acknowledgeUpdateOH(props.savedOHId, props.id)}
          >
            Got it
          </S.GotItButton>
        </S.Confirmation>
      )}
      {props.isPastOH && !props.hideActions && (
        <PastOpenHouseActions
          hasAnswer={props.hasAnswer}
          openHouseId={props.id}
          savedOHId={props.savedOHId}
        />
      )}
    </>
  );
};

OpenHouseItemActivity.propTypes = {
  isCanceled: bool,
  isTimeChanged: bool,
  hasAnswer: bool,
  hideActions: bool,
  imageUrl: string,
  listingLink: string,
  listingId: string,
  listingAddress: string,
  endsAt: string.isRequired,
  id: string.isRequired,
  openHouseData: shape({}).isRequired,
  isPastOH: bool,
  startsAt: string.isRequired,
  savedOHId: string
};

OpenHouseItemActivity.defaultProps = {
  isCanceled: false,
  isTimeChanged: false,
  hasAnswer: false,
  hideActions: false,
  imageUrl: "",
  listingLink: "",
  listingId: "",
  listingAddress: "",
  isPastOH: false,
  savedOHId: ""
};

export default OpenHouseItemActivity;
